export default __webpack_public_path__ + "static/media/logo.0dc2fda6.png";